<template>
    <div class="prop-container">
        <!-- 对齐方式 -->
        <div class="align-nodes">
            <div class="zt icon-jurassic_horizalign-left" title="左对齐" @click="alignNodes(alignNodesType.left)"></div>
            <div class="zt icon-jurassic_horizalign-right" title="右对齐" @click="alignNodes(alignNodesType.right)"></div>
            <div class="zt icon-jurassic_horizalign-center" title="居中对齐" @click="alignNodes(alignNodesType.center)">
            </div>
            <div class="zt icon-jurassic_verticalalign-bottom" title="底部对齐" @click="alignNodes(alignNodesType.bottom)">
            </div>
            <div class="zt icon-jurassic_verticalalign-top" title="顶部对齐" @click="alignNodes(alignNodesType.top)"></div>
            <div class="zt icon-jurassic_verticalalign-center" title="垂直居中对齐"
                @click="alignNodes(alignNodesType.middle)"></div>
        </div>
        <!-- 通用属性 -->
        <div v-for="(item, key) in props" :key="key">
            <strong> {{ key }} </strong>

            <template v-for="(item2, key2) in item">
                <div v-if="key2 !== 'category'" :key="key2" class="prop-item">
                    <div class="label">
                        <span>{{ item2.label }}</span>
                        <span v-if="item2.desc">
                            <el-tooltip :content="item2.desc" placement="top">
                                <i class="el-icon-question desc"></i>
                            </el-tooltip>
                        </span>
                    </div>
                    <div class="input-info">
                        <!-- 字符串 -->
                        <el-input v-model="item2.value" size="mini" v-if="item2.type === propsTypes.string"
                            placeholder="请输入内容" @change="updateProp(item2, key2)"></el-input>
                        <!-- 字符 -->
                        <el-input-number v-if="item2.type === propsTypes.number" v-model="item2.value"
                            controls-position="right" @change="updateProp(item2, key2)" size="mini"></el-input-number>
                        <!-- 颜色 -->
                        <el-color-picker v-model="item2.value" size="mini" :show-alpha="true"
                            v-if="item2.type === propsTypes.color" :popper-class="'popper-color-prop'"
                            @change="updateProp(item2, key2)"></el-color-picker>

                        <!-- 枚举 -->
                        <el-select v-model="item2.value" size="mini" v-if="item2.type === propsTypes.eumn"
                            placeholder="请选择" @change="updateProp(item2, key2)">
                            <el-option v-for="selectitem in item2.options" :key="selectitem.value"
                                :label="selectitem.label" :value="selectitem.value">
                            </el-option>
                        </el-select>
                        <!-- switch -->
                        <el-switch v-if="item2.type === propsTypes.switch" v-model="item2.value" active-color="#13ce66"
                            inactive-color="#ff4949" @change="updateProp(item2, key2)">
                        </el-switch>
                        <!-- {{ item2.value }} -->
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import Core from "@/libs/src/core";
import _propdata from "../types/commonProps";
import { propsTypes } from "../types/sprite-types";

export default {
    name: "prop-component",
    data() {
        return {
            props: {},
            propsTypes: propsTypes,
            jsonData: {},
            alignNodesType: {
                left: 'left',
                right: 'right',
                center: 'center',
                top: 'top',
                bottom: 'bottom',
                middle: 'middle'
            },
        };
    },

    created() {
        this.topo = Core.getProvider("TechnologyTopo");
        this.init();
    },

    methods: {
        init() {
            let props = {};
            const propdata = JSON.parse(JSON.stringify(_propdata));
            for (let i = 0, len = propdata.length; i < len; i++) {
                if (!props[propdata[i].category]) {
                    props[propdata[i].category] = {};
                }
                Object.keys(propdata[i]).forEach((k) => {

                    props[propdata[i].category][k] = propdata[i][k];
                });
            }

            this.props = Object.assign({}, this.props, props);

            this.active = this.topo.store ? this.topo.store.active : [];
        },

        alignNodes(type) {
            this.topo.stageCanvas.alignNodes(type, this.active);
        },

        //更新属性
        updateProp(prop, key) {
            this.active.forEach(item => {
                if (item[key] !== prop.value) {
                    this.topo.stageCanvas._setValue({
                        id: item.id,
                        [key]: prop.value,
                    });
                }
            })

            this.topo.stageCanvas.render();

        },

    },
};
</script>
<style lang="scss" scoped>
.prop-container {
    height: calc(100vh - 170px);
    overflow-y: auto;

    .align-nodes {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 200px;

        .zt {
            cursor: pointer;
        }
    }
}

.desc {
    cursor: pointer;
    margin-left: 5px;
}

.prop-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #515151;

    .label {
        width: 120px;
        text-align: right;
        padding-right: 10px;
    }
}
</style>